import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../Notifications/ToastifyActions";

function SaveNotificationTypeLookupService(token, data) {

    return axios.post(
        `${CURRENT_API_URL}/amazonNotifications/saveNotificationTypeLookup`,
        data,
        {
            headers: {
                Authorization: token,
            },
        }
    )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            console.log(error);
            notify.NotifyError(
                "Unable to save notification setting."
            );
            return false;
        });
}

export default SaveNotificationTypeLookupService;
